export default "__VITE_ASSET__040bd010__"